import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import GeoPoint from '@/models/Shared/GeoPoint';

export default class CreateBranchRequest extends BaseUpdateRequest {
    registeredName = '';    
    brandName = '';
    emailAddress = '';
    phoneNumber = '';
    taxNumber = '';    
    registrationNumber = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    website = '';
    biography = '';
    avatar = '';
}